export const contractsSliceName = "contracts"
